export function listBmItem(params) {
    return window.axios.post("api/bmItem/list", params)
}

export function deleteBmItem(id) {
    return window.axios.post("api/bmItem/delete", { id: id })
}

export function batchDeleteBmItem(id) {
    return window.axios.post("api/bmItem/batchDelete", { ids: id })
}

export function updateBmItem(params) {
    return window.axios.post("api/bmItem/update", params)
}

export function updateTlName(params) {
    return window.axios.post("api/bmItem/updateTlName", params)
}


export function clearBmItem(params) {
    return window.axios.post("api/bmItem/clear", params)
}

export function addBmItem(params) {
    return window.axios.post("api/bmItem/add", params)
}

export function getBmItem(id) {
    return window.axios.post("api/bmItem/get", { id: id })
}

export function getNumByUser(params) {
    return window.axios.post("api/bmItem/getNumByUser", params)
}

export function exportBmItem(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/exceltwo", params, config)
}

export function exportConfigPermission(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/exportConfigPermission", params, config)
}
export function exportConfigFormat(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/exportConfigFormat", params, config)
}

export function exportmedalTally(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/exportmedalTally", params, config)
}
export function getTlNameNum(params) {
    return window.axios.post("api/bmItem/getTlNameNum", params)
}

export function getMiXi(params) {
    return window.axios.post("api/bmItem/getMiXi", params)
}

export function getmedalTally(params) {
    return window.axios.post("api/bmItem/medalTally", params)
}

export function getTableConfig(params) {
    return window.axios.post("api/bmItem/getConfig", params)
}

export function exceltwoConfig(params) {
    return window.axios.post("api/bmItem/exceltwoConfig", params)
}

export function exceltoneConfig(params) {
    return window.axios.post("api/bmItem/exceltoneConfig", params)
}

export function getAllJtAthleteStatistics(params) {
    return window.axios.post("api/bmItem/getAllJtAthleteStatistics", params)
}

export function initJtBianPaiData(params) {
    return window.axios.post("api/bmItem/initJtBianPaiData", params)
}

export function initTlBianPaiData(params) {
    return window.axios.post("api/bmItem/initTlBianPaiData", params)
}

export function updateTlSort(params) {
    return window.axios.post("api/bmItem/updateTlSort", params)
}

export function updateNeedTime(params) {
    return window.axios.post("api/bmItem/updateNeedTime", params)
}

export function updateSingleNum(params) {
    return window.axios.post("api/bmItem/updateSingleNum", params)
}

export function updateAddress(params) {
    return window.axios.post("api/bmItem/updateAddress", params)
}

export function updateTlChildSort(params) {
    return window.axios.post("api/bmItem/updateTlChildSort", params)
}

export function updateJtSort(params) {
    return window.axios.post("api/bmItem/updateJtSort", params)
}


export function getAllTlAthleteStatistics(params) {
    return window.axios.post("api/bmItem/getAllTlAthleteStatistics", params)
}


export function getAllAddressData(params) {
    return window.axios.post("api/bmItem/getAllAddressData", params)
}


export function exportAllAddressData(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/exportAllAddressData", params, config)
}
export function exportAllCompentionData(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/exportAllCompentionData", params, config)
}

export function getAllCompentionData(params) {
    return window.axios.post("api/bmItem/getAllCompentionData", params)
}
export function getTlAddress(params) {
    return window.axios.post("api/bmItem/getTlAddress", params)
}
export function getTlJoinDate(params) {
    return window.axios.post("api/bmItem/getTlJoinDate", params)
}

export function getAllBaoMingData(params) {
    return window.axios.post("api/bmItem/getAllBaoMingData", params)
}

export function updateJtAddress(params) {
    return window.axios.post("api/bmItem/updateJtAddress", params)
}

export function updateTlAddress(params) {
    return window.axios.post("api/bmItem/updateTlAddress", params)
}

export function exportAllJtAthleteStatisticsConfig(params) {
    return window.axios.post("api/bmItem/exportAllJtAthleteStatisticsConfig", params)
}

export function exportAllTlAthleteStatisticsConfig(params) {
    return window.axios.post("api/bmItem/exportAllTlAthleteStatisticsConfig", params)
}

export function exportBmItemone(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/exceltone", params, config)
}

export function exportAllJtAthleteStatistics(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/exportAllJtAthleteStatistics", params, config)
}

export function exportAllTlAthleteStatistics(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/exportAllTlAthleteStatistics", params, config)
}

export function excelthree(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/excelthree", params, config)
}

export function excelthreeAll(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/excelthreeAll", params, config)
}

export function excelthreemore(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/bmItem/export/excelthreemore", params, config)
}
